<!-- src/components/Avatar.vue -->
<template>
  <div class="avatar-wrapper">
    <div class="avatar-circle">
      <div style="font-weight: 400; color:rgb(255, 255, 255)">{{ firstChar }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvatarComponent',
  props: {
    username: {
      type: String,
      default: 'U'
    },
  },
  computed: {
    firstChar() {
      return this.username && this.username.length > 0 
        ? this.username.charAt(0).toUpperCase() 
        : 'U';
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.avatar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.avatar-circle {
  width: 80%; /* 父容器宽度的70% */
  aspect-ratio: 1 / 1; /* 宽高比1:1，保持正方形 */
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); /* 指定的渐变色 */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 4px 12px rgba(76, 29, 149, 0.3);
  transition: all 0.2s ease;
}

.avatar-circle:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(76, 29, 149, 0.4);
}

.avatar-circle:active {
  transform: scale(0.95);
}

.avatar-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: clamp(24px, 8vw, 48px); /* 响应式字体大小 */
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 如果需要点击效果 */
.avatar-wrapper {
  cursor: pointer;
}

/* 如果不可点击 */
.avatar-wrapper:not(.clickable) {
  cursor: default;
}

.avatar-wrapper:not(.clickable) .avatar-circle:hover {
  transform: none;
  box-shadow: 0 4px 12px rgba(76, 29, 149, 0.3);
}
</style>